const RESERVED_SUBDOMAINS = ['staging', 'main', 'testing'];

export default RESERVED_SUBDOMAINS;
